import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { map, tap } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { ConfirmDialogData } from 'src/app/shared/components/dialogs/dialog-data';
import { AlertService } from 'src/app/shared/services/alert-service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { LoginService } from 'src/app/shared/services/login.service';

export type User = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  job?: string;
  obj?: any;
};
@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class MyAccountComponent implements OnInit {
  formUser!: FormGroup;
  changePasswordForm: FormGroup;
  confirmDelAccForm: FormGroup;
  visible: boolean = false;
  visiblePopupDelAccount: boolean = false;
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  submitted = false;
  regex: RegExp = /^(?=.*[0-9])(?=.*[}+\-_*&$#@!^()[\]{}\\|;:'",.<>/?`~éàè€£ù²§°])(?!.*[ \t\r\n\v\f])(?=.*[a-zA-Z])[a-zA-Z0-9}{+\-_*&$#@!^()[\]{}\\|;:'",.<>/?`~éàè€£ù²§°]{8,}$/;
  validators = [Validators.required, Validators.minLength(8), Validators.pattern(this.regex)];
  userId = localStorage.getItem('userid');
  currentUser: any;

  constructor(private _fb: FormBuilder,
    private userService: UserService,
    private _commonService: CommonService,
    private _alertService: AlertService,
    private loginService: LoginService,
    private dynamicDocumentService: DynamicDocumentService,
    private datePipe: DatePipe,
    private _messageService: MessageService) { }

  ngOnInit() {
    this.initForm();
    this.getInfoProfile();
    this.formUser.get('email')?.disable();
  }
  get f() {
    return this.changePasswordForm.controls;
  }
  initForm(): void {
    this.formUser = this._fb.group({
      nom: '',
      prenom: '',
      email: ['', Validators.required],
      tel: '',
      func: '',
    });
    this.confirmDelAccForm = this._fb.group({
      password: ['', this.validators],
      reason: ['', this.validators],
    });
    this.changePasswordForm = this._fb.group(
      {
        password: ['', this.validators],
        newPassword: ['', this.validators],
        confirmPassword: [
          '',
        ],
        token: ['', Validators.compose([Validators.required])],
      },
      {
        validators: (control: any) => {
          if (control.value.newPassword !== control.value.confirmPassword) {
            control.get('confirmPassword')?.setErrors({ notMatch: true });
          }
        },
      }
    );
  }
  showDialogChangePass() {
    this.showCurrentPassword = false;
    this.submitted = false;
    this.visible = true;
    this.changePasswordForm.reset();
  }
  showDialogDelAccount() {
    this.showCurrentPassword = false;
    this.visiblePopupDelAccount = true;
  }
  togglePassword(type: string) {
    if (type == 'current') {
      this.showCurrentPassword = !this.showCurrentPassword;
    }
    if (type == 'new') {
      this.showNewPassword = !this.showNewPassword;
    }
    if (type == 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
  getInfoProfile(): void {
    this._commonService.getUser(this.userId).subscribe({
      next: (res) => {
        this.currentUser = res;
        this.formUser.patchValue({
          nom: res?.lastName,
          prenom: res?.firstName,
          email: res?.email,
          tel: res?.phone,
          func: res?.job,
        });
      },
      error: (error) => { },
    });
  }
  onSubmitChangePass(): void {
    this.submitted = true;
    if (this.changePasswordForm.invalid) {
      return;
    }
  }
  changePassword() {
    // this.dialog.open(ChangePasswordComponent);

    let dialog: ConfirmDialogData = {
      title: 'Modification de mot de passe',
      message: 'Êtes-vous sûr de demander le changement de mot de passe',
      cancelText: `Non`,
      confirmText: `Oui`,
    };
    this._alertService.confirmDialog(dialog).subscribe((isOK) => {
      if (isOK && this.currentUser?.email) {
        this.loginService.sendRecoveryLink(this.currentUser.email).subscribe((resp: any) => {
          dialog.message = resp.responseMessage;
          // dialog.isAlert = true;
          this._alertService.confirmDialog(dialog).subscribe();
        });
      }
    });
  }
  save() {
    if (!this.formUser.valid || !this.currentUser) {
      return;
    }

    this.currentUser.firstName = this.formUser.get('prenom')?.value || '';
    this.currentUser.lastName = this.formUser.get('nom')?.value || '';
    this.currentUser.email = this.formUser.get('email')?.value || '';
    this.currentUser.phone = this.formUser.get('tel')?.value || '';
    this.currentUser.job = this.formUser.get('func')?.value || '';

    this.currentUser.updatingDate = this.datePipe.transform(Date.now(), "yyyy-MM-dd'T'00:00:00");
    this.currentUser.dateOfLastConnectionToTheIntranetSite = this.datePipe.transform(
      this.currentUser.dateOfLastConnectionToTheIntranetSite,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.currentUser.resetTokenDateTime = this.datePipe.transform(
      this.currentUser.resetTokenDateTime,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.currentUser.creationDate = this.datePipe.transform(
      this.currentUser.creationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.dynamicDocumentService
      .saveDocument('dynamic_natural_person', this.currentUser, true)
      .subscribe({
        next: (res) => {
          const user = this.convertUser(res);
          this._messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Les détails de l'utilisateur ont été enregistrés avec succès",
            life: 3000
          });
          this.getUserDetailSuccess(user);
        },
        error: (err) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Échec de l'enregistrement des détails de l'utilisateur",
            life: 3000
          });
        }
      });
  }
  convertUser(user: any): User {
    return {
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      phone: user?.phone,
      job: user?.job,
    };
  }
  getUserDetailSuccess(user: User) {
    this.currentUser = user;
    this.formUser.patchValue({
      nom: user.lastName,
      prenom: user.firstName,
      email: user.email,
      tel: user.phone,
      func: user.job,
    });
  }
  delAcc(): void {
    // if (this.confirmDelAccForm.invalid) {
    //   return;
    // }
    const payload = {
      "mailsubject": "Demande de suppression de compte",
      "mailfrom": this.currentUser?.email,
      "mailcontent": this.confirmDelAccForm.value.password + "-" + this.confirmDelAccForm.value.reason
    }
    this._commonService.sendEmailDelAcc(payload).subscribe({
      next: (res) => {
        this.visiblePopupDelAccount = false;
        this._messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: "La demande de suppression de compte a été envoyée",
          life: 3000
        });
      },
      error: (error) => {
        this._messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: "La demande de suppression de compte a échoué",
          life: 3000
        });
      },
    });
  }
}
